import { inject } from "@angular/core";
import { Routes, CanActivate } from "@angular/router";
import { AuthComponent } from "src/app/auth/auth.component";
import { AuthRoutes } from "src/app/auth/auth.routes";
import { LoginComponent } from "src/app/auth/login/login.component";
import { AuthGuard } from "src/app/auth/services/auth-guard";
import { SignupComponent } from "src/app/auth/signup/signup.component";
import { BinstComponent } from "src/app/binst/binst.component";
import { CanvasDebuggerComponent } from "./binst/tests/canvas-debugger/canvas-debugger.component";
import { PostTestComponent } from "./binst/tests/post.test/post.test.component";
import { ClassicBinstComponent } from "./binst/tests/classic-binst/classic-binst.component";
import {ProfileComponent} from "./interface-components/profile/profile.component";
import {SearchPaneComponent} from "./interface-components/search-pane/search-pane.component";
import {EditProfileComponent} from "./interface-components/edit-profile/edit-profile.component";
import {ChatsBarComponent} from "./interface-components/chats-bar/chats-bar.component";
import {NewImageComponent} from "./interface-components/new-image/new-image.component";
import {
  EditProfileCropImageComponent
} from "./interface-components/edit-profile-crop-image/edit-profile-crop-image.component";
import {ChatComponent} from "./interface-components/chat/chat.component";
import {ContextProfileComponent} from "./interface-components/context-profile/context-profile.component";
import {ChatNewComponent} from "./interface-components/chat-new/chat-new.component";
import {
  GoogleAuthServerResponseValidatorComponent
} from "./auth/auth-providers/google-auth-server-response-validator/google-auth-server-response-validator.component";
import {MultiplexCanvasComponent} from "./binst/tests/feature/multiplex-canvas/multiplex-canvas.component";
import {ContextShareComponent} from "./interface-components/context-share/context-share.component";
import {PrivacyPolicyComponent} from "./policies/privacy-policy/privacy-policy.component";
import {TermsOfServiceComponent} from "./policies/terms-of-service/terms-of-service.component";
import {NewFlyerComponent} from "./interface-components/new-flyer/new-flyer.component";
import {ContextNewSelectorComponent} from "./interface-components/context-new-selector/context-new-selector.component";
import {NewMapReactionComponent} from "./interface-components/new-map-reaction/new-map-reaction.component";
import {
  PaneProfileDropdownComponent
} from "./interface-components/pane-profile-dropdown/pane-profile-dropdown.component";
import {ContextPostComponent} from "./interface-components/context-post/context-post.component";

export const routes: Routes = [
  {
    path: "",
    component: BinstComponent,
    canActivate: [() => inject(AuthGuard).canActivate()],
    children: [
      { path: 'profile', component: ProfileComponent, outlet: 'right-pane' },
      { path: 'profile-dropdown', component: PaneProfileDropdownComponent, outlet: 'pop-up-top-right' },
      { path: 'chat-bar', component: ChatsBarComponent, outlet: 'left-pane' },
      { path: 'chat', component: ChatComponent, outlet: 'left-pane' },
      { path: 'new-chat', component: ChatNewComponent, outlet: 'left-pane' },
      { path: 'profile-left', component: ProfileComponent, outlet: 'left-pane' },
      { path: 'profile-edit', component: EditProfileComponent, outlet: 'right-pane' },
      { path: 'profile-edit-image', component: EditProfileCropImageComponent, outlet: 'right-pane'},
      { path: 'search', component: SearchPaneComponent, outlet: 'right-pane' },
      { path: 'new-images', component: NewImageComponent, outlet: 'new-modal-pane' },
      { path: 'new-flyer', component: NewFlyerComponent, outlet: 'new-modal-pane' },
      { path: 'new-map-reaction', component: NewMapReactionComponent, outlet: 'new-modal-pane' },
      { path: 'context-profile', component: ContextProfileComponent, outlet: 'context-menu' },
      { path: 'context-post', component: ContextPostComponent, outlet: 'context-menu' },
      { path: 'context-share', component: ContextShareComponent, outlet: 'context-menu' },
      { path: 'context-new-select', component: ContextNewSelectorComponent, outlet: 'context-menu' },
    ],
  },
  {
    path: "multiplex-canvas",
    component: MultiplexCanvasComponent,
    canActivate: [() => inject(AuthGuard).canActivate()],
  },
  {
    path: "classic",
    component: ClassicBinstComponent,
    canActivate: [() => inject(AuthGuard).canActivate()],
  },
  {
    path: "post-test",
    component: PostTestComponent,
    canActivate: [() => inject(AuthGuard).canActivate()],
  },
  {
    path: "canvas-debugger",
    component: CanvasDebuggerComponent,
    canActivate: [() => inject(AuthGuard).canActivate()],
  },
  {
    path: "privacy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "terms-of-service",
    component: TermsOfServiceComponent,
  },
  {
    path: "auth",
    component: AuthComponent,
    children: [
      {
        path: "google/success",
        component: GoogleAuthServerResponseValidatorComponent,
      },
      {
        path: "enter",
        component: LoginComponent,
      },
      {
        path: "signup",
        component: SignupComponent,
      },
      { path: "", redirectTo: "enter", pathMatch: "full" },
      { path: "**", redirectTo: "enter" },
    ],
  },
  { path: "", redirectTo: "auth/enter", pathMatch: "full" },
  { path: "**", redirectTo: "auth/enter" },
];
